import React from 'react';

function LoadViewer(props) {
    return (
        <div className='ships-viewer__load-viewer-text-container'>
            <h2 className='ships-viewer__load-viewer-heading'>EXPLORE APPLICATION AREAS TO FIND THE RIGHT PRODUCT OR SOLUTION</h2>
            <button type='button'
                    className='ships-viewer__load-viewer-btn btn btn--primary btn--big btn--outline'
                    onClick={props.handleClick}
            >
                Start exploring
            </button>
        </div>
    );
}

export default LoadViewer;